import { authRequest } from "./authRequest";

export default authRequest;
